import React, { useState } from 'react';
import ReactTable from 'react-table';
import { isAuthenticated } from '../../../../store/action/auth';
import Modal from '../../../../components/molecules/Modal';
import {
  courierWithCoordinates,
  courierWithInstantPickup
} from "../../../../services/helpers/courier";
import ReactTooltip from "react-tooltip";
import {
  deleteOrder,
  updateOrderStatus,
  updateTestOrderStatus
} from "../../../../store/action/order";
import { Dropdown } from "react-bootstrap";
import {PDFDownloadLink} from "@react-pdf/renderer";
import WaybillOrder from "../../../../components/templates/pdfs/waybillLabel";
import QRCode from "qrcode.react";
import WaybillBulkOrder from "../../../../components/templates/pdfs/waybillBulkLabel";
import ModalOrderDetail from "../ModalOrderDetail";
import EditOrderForm from "../../../../components/forms/EditOrderForm";
import { trackEvent } from "../../../../services/analytics";
import Status from '../../helpers/status';
import TableComponents from './TableComponents';
import { ModalEditTags, ModalFulfillment } from './ModalComponents';

const OrderTable = props => {
  const [ modal, setModal ] = useState(false);
  const [ modalType, setModalType ] = useState('history');
  const [ data, setData] = useState({});
  const [ selectedOrderId, setSelectedOrderId ] = useState('');
  const [ selectedOrders, setSelectedOrders ] = useState([]);
  const [ editOrderModal, setEditOrderModal ] = useState(false);
  const [ testData, setTestData ] = useState(localStorage.getItem('biteship_test_data')||'notActive') 
  const [ qrCode, setQrCode ] = useState('');
  const selectedData = props.data.filter(i => i.selected);
  const totalSelected = selectedData.length;
  const [ cancellationReason, setCancellationReason ] = useState('');
  const { token, user } = isAuthenticated();
  const isUserFulfillment = user.integrations && user.integrations.filter(i => i.scopes.includes("write_fulfillment")).length > 0;

  const cancelReasons = [
    "Pilih...",
    "Ingin mengganti kurir",
    "Waktu penjemputan terlalu lama",
    "Tidak ada konfirmasi",
    "Ingin mengganti alamat",
    "Harga kurir tidak sesuai",
    "Barang belum siap",
    "Lainnya"
  ];
  const columns = [{
      header: '',
      Header: ({row,original})  => checkBoxes('header',original),
      accessor: 'editButton',
      Cell: ({row,original})  => checkBoxes('row',original,row._index),
      className:'text-center',
      headerClassName: 'text-center',
      headerStyle: { overflow: 'visible'},
      minWidth: 40,
      sortable: false,
    },{
      Header: 'ASAL / TUJUAN',
      headerStyle: { paddingLeft: totalSelected > 0 ? '72px' : null},
      minWidth: 200,
      style: { 'whiteSpace': 'unset'},
      accessor: 'receiverName',
      Cell: ({row, original}) => <TableComponents.Address data={original} test={testData}/>
    },{
      Header: 'BARANG',
      maxWidth: 200,
      className:'px-3',
      accessor: 'items',
      style: { 'whiteSpace': 'unset'},
      Cell: ({row, original}) => <TableComponents.Item data={original}/>
    },{
      Header: 'PAYMENT',
      minWidth: 80,
      className:'px-3',
      accessor: 'price',
      style: { 'whiteSpace': 'unset'},
      Cell: ({row, original}) => <TableComponents.Price data={original} user={user} test={testData}/>
    },{
      Header: 'STATUS',
      accessor: 'status',
      className:'status-container',
      style: { 'whiteSpace': 'unset', 'color':'#3B196C'},
      maxWidth: 100,
      Cell: ({row, original}) => <TableComponents.Status data={original}/>
    },{
      Header: 'KURIR',
      accessor: 'courier',
      minWidth: 100,
      className:'px-3',
      style: { 'whiteSpace': 'unset'},
      Cell: ({row, original}) => <TableComponents.Courier data={original} test={testData} onClickTag={id => onShowModal(id,'tags')}/>
    },{
      Header: 'TANGGAL PENGIRIMAN',
      maxWidth: 100,
      accessor: 'deliveryDate',
      headerStyle: { 'whiteSpace': 'unset'},
      className:'text-center',
      style: { 'whiteSpace': 'unset'},
      Cell: ({row, original}) => <TableComponents.Time data={row}/>
    },{
      Header: 'AKSI',
      maxWidth: 80,
      accessor: 'edit',
      className:'text-center',
      headerClassName: 'text-center',
      style: { 'whiteSpace': 'unset'},
      Cell: ({row,original}) => editOrder(row._index,original)
    }
  ];

  const handleModalClose = () => {
    setModal(false);
    setSelectedOrderId("");
  };

  const updateTestOrder = async (orderId, status) => {
    try {
      const res = await updateTestOrderStatus(token, orderId, status)
      
      if (!res.success) {
        alert('Failed to update order')  
      }
      alert(res.message)  
      window.location.reload()
    } catch (e) {
      alert('Failed to update order')
    }
  }

  const checkBoxes = (type,value,index) => {
      const availableForConfirm = props.data.filter(i =>
          i.status === 'placed' &&
          i.selected && (
            courierWithInstantPickup(i.courierCompany) ||
            i.orderType === 'form'
          )
      );

      const availableForFulfillment = props.data.filter(i => i.fulfillmentOrderId === null && i.selected);
      const totalData = props.data.length;
      const totalAvailableConfirm = availableForConfirm.length;
      const totalAvailableForFulfillment = availableForFulfillment.length;
      
      if (props.tab === 'notActive' || props.tab === 'action' ) {
          return null
      } else if (type === 'header') {
          return (
              <Dropdown className="btn-group btn-group-sm">
                  <Dropdown.Toggle
                      id="dropdown-basic"
                      className={`${totalSelected > 0 ? 'btn-primary text-white shadow' : 'btn-secondary'} 
                        order-table-action-button py-1 px-2 btn-sm dropdown-toggle`
                      }
                      style={{'fontSize':'12px', 'marginTop':'-5px', 'zIndex':99}}
                  >
                      {totalSelected > 0 ? `(${totalSelected}) TERPILIH` : 'PILIH'}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu-scroll">
                      <Dropdown.Header>{totalSelected > 0 ? totalSelected : 'Belum ada'} pesanan terpilih</Dropdown.Header>
                      <Dropdown.Divider/>
                      {
                          totalSelected === totalData ?
                              <Dropdown.Item onClick={() => props.onClickCheckBox(type,value)} className="text-info text-">
                                  Hilangkan Pilihan
                              </Dropdown.Item>
                              :
                              <Dropdown.Item onClick={() => props.onClickCheckBox(type,value)} className="text-info text-">
                                  Pilih Semua
                              </Dropdown.Item>
                      }
                      {
                          props.tab === 'active' || props.tab === 'picked' ? null :
                              <Dropdown.Item
                                  onClick={() => props.onConfirmBatchOrder(availableForConfirm)}
                                  disabled={!totalAvailableConfirm > 0}
                                  className={`${totalAvailableConfirm > 0 ? null : 'text-muted'} text-info text-`}
                              >
                                  Konfirmasi {totalAvailableConfirm > 0 ? totalAvailableConfirm: null} Pesanan
                              </Dropdown.Item>
                      }
                      
                      <Dropdown.Item
                          onClick={() => onPrintSelected(selectedData)}
                          disabled={!totalSelected > 0}
                          className={`${totalSelected > 0 ? null : 'text-muted'} text-info text-`}
                      >
                          Print {totalSelected > 0 ? totalSelected : null} Pesanan
                      </Dropdown.Item>
                      <Dropdown.Item
                          onClick={() => onEditTagsSelected(selectedData)}
                          disabled={!totalSelected > 0}
                          className={`${totalSelected > 0 ? null : 'text-muted'} text-info text-`}
                      >
                          Update Tags {totalSelected > 0 ? totalSelected : null} Pesanan
                      </Dropdown.Item>
                      {
                        !isUserFulfillment ? null :
                          <div>
                            <hr className='my-2'/>
                            <Dropdown.Item
                                onClick={() => onClickFulfill(availableForFulfillment)}
                                disabled={!totalAvailableForFulfillment > 0}
                                className={`${totalAvailableForFulfillment > 0 ? null : 'text-muted'} text-info text-`}
                            >
                                Kemas {totalAvailableForFulfillment > 0 ? totalAvailableForFulfillment : null} Pesanan
                            </Dropdown.Item>
                          </div>
                      }
                      <hr className='my-2'/>
                      <Dropdown.Item
                          onClick={() => props.onDeleteBatchOrder(selectedData)}
                          disabled={!totalSelected > 0}
                          className={`${totalSelected > 0 ? null : 'text-muted'} text-danger text-`}
                      >
                          Cancel {totalSelected > 0 ? totalSelected : null} Pesanan
                      </Dropdown.Item>

                  </Dropdown.Menu>
              </Dropdown>
          )
      } else {
          return (
              <label htmlFor={`${value.orderId}`} className="si si-checkbox mt-2">
                  <input
                      onChange={() => props.onClickCheckBox(type,value,index)}
                      type="checkbox"
                      checked={value.selected}
                      id={`${value.orderId}`}
                  />
                  <span className="si-label"></span>
              </label>
          )
      }
  };

  const onShowModal = async (orderId, modalType, type) => {
    setSelectedOrderId(orderId)
    setModal(true);
    setModalType(modalType);
  };

  const onClickPrint = (data) => {
      setModal(true);
      setData(data);
      setModalType('print')
  };

  const onClickPay = async (idx,data) => {
      props.onClickPayment(idx,data);
  };

  const onPrintSelected = (data) => {
      setModal(true);
      setData(data);
      setModalType('printSelected')
  };

  const onEditTagsSelected = (data) => {
    setModal(true);
    setData(data);
    setModalType('tags')
  }

  const onClickFulfill = (data) => {
    setModal(true);
    setData(data);
    setSelectedOrders(data);
    setSelectedOrderId(data[0].orderId)
    setModalType('fulfillment')
  }

  const onDeleteOrder = async () => {
    if (cancellationReason === '' || cancellationReason === 'Pilih...') {
      alert("Pilih alasan kenapa Anda cancel.");
      return
    }
    const environment = testData === 'active' ? 'development' : 'production';
    deleteOrder(token, selectedOrderId, cancellationReason,environment)
      .then(async res => {
        if(res.success){
          await trackEvent("Order Cancelled",{
            action: "track",
            category: "Orders",
            label: 'Cancel Order From Dashboard',
            event: "Click"
          });

          alert(`Berhasil dihapus`);
          window.location.reload()
        } else {
          alert(res.error)
        }
      });
  };

  const onUpdateOrder = (orderId, status) => {
    const environment = testData === 'active' ? 'development' : 'production';
    if(window.confirm('Kami akan segera mempesan order kamu. Kamu yakin?')) {
      updateOrderStatus(token, orderId, status,environment)
        .then(res => {
          if(res.success){
            alert(`Kami segera mempesan. Mohon ditunggu :)`);
            window.location.reload()
          } else {
            alert(res.error)
          }
        })
    }
  };

  const editOrder = (idx,og) => {
    let {status, orderId, orderType, courierCompany, courierWaybillId, loading, receiverCoordinate } = og;

    let update;
    if ((status === 'placed' || status === 'scheduled') && (courierWithInstantPickup(courierCompany) || orderType === 'form')){
        if (orderType === 'woocommerce' && courierWithCoordinates(courierCompany) && !receiverCoordinate.latitude) {
            update = (
                <div className="mb-2 pointer">
                    <ReactTooltip/>
                    <a onClick={() => {
                        setSelectedOrderId(orderId);
                        setEditOrderModal(true)
                    }}
                       className="action-item mr-2"
                       data-tip="Kirim pesanan ini"
                       title="Send">
                        <i className="fas fa-edit"></i>
                    </a><br/>
                    <small>EDIT</small>
                </div>
            )
        } else {
            update = (
                <div className="mb-2 pointer">
                    <ReactTooltip/>
                    <a onClick={() => onUpdateOrder(orderId,'confirmed')}
                       className="action-item mr-2"
                       data-tip="Kirim pesanan ini"
                       title="Send">
                        <i className="fas fa-truck"></i>
                    </a><br/>
                    <small>KIRIM</small>
                </div>
            )
        }
    } else {
      update = null;
    }

    let trash;
    if (Status.isStatusCannotCancel(status)) {
      trash = (
          <div className="mb-2 text-light">
            <ReactTooltip/>
            <a className="action-item mr-2"
               data-tip="Pesanan tidak dapat dibatalkan"
               title="Trash">
              <i className="fas fa-trash"></i>
            </a><br/>
            <small>CANCEL</small>
          </div>
      )
    } else {
      trash = (
        <div className="mb-2 pointer">
          <ReactTooltip/>
          <a onClick={() => onShowModal(orderId,'delete')}
             className="action-item mr-2"
             data-tip="Cancel pesanan ini"
             title="Trash">
            <i className="fas fa-trash"></i>
          </a><br/>
          <small>CANCEL</small>
        </div>
      )
    }

    let linkView;
    if (orderId && testData === 'notActive') {
      linkView = (
          <div className="mb-2 pointer">
            <ReactTooltip/>
            <a onClick={() => onShowModal(orderId,'detail')}
               className="action-item mr-2"
               data-tip="Lihat tracking pesanan"
               title="Tracking">
              <i className="fas fa-map"></i>
            </a><br/>
            <small>DETAIL</small>
          </div>
      );
    } else {
      linkView = null;
    }

    if (!update && !trash && !linkView) {
      return <div className="text-muted"><i>Tidak dapat diubah</i></div>
    }

    let print;
    if ((status === 'confirmed' || status === 'allocated' || status === 'pickingUp') && courierWaybillId ) {
        print = (
            <div className="mb-2 pointer">
                <ReactTooltip/>
                <a onClick={() => onClickPrint(og)}
                   className="action-item mr-2"
                   data-tip="Cetak label pesannan"
                   title="Print">
                    <i className="fas fa-print"></i>
                </a><br/>
                <small>PRINT</small>
            </div>
        );
    }  else {
        print = null
    }

    let payment;
    if (status === 'pending') {
        payment = (
            <div className="mb-2 pointer">
                <ReactTooltip/>
                <a onClick={() => onClickPay(idx,og)}
                    className="action-item mr-2"
                    data-tip="Lakukan pembayaran"
                    title="Payment">
                    <i className="fas fa-money-bill-wave"></i>
                </a><br/>
                {
                    loading ? `Membayar...` : <small>BAYAR</small>
                }
            </div>
        );
    }  else {
        payment = null
    }

    // fulfillment actions
    let fulfillment;
    if (isUserFulfillment && !og.fulfillmentOrderId && Status.isStatusAvailableForFulfillment(og.status)) {
      fulfillment = (
        <div className="mb-2 pointer">
            <ReactTooltip/>
            <a onClick={() => onClickFulfill([og])}
                className="action-item mr-2"
                data-tip="Kemas Pengiriman"
                title="Fulfillment">
                <i className="fas fa-warehouse"></i>
            </a><br/>
            <small>KEMAS</small>
        </div>
      )
    } else {
      fulfillment = null
    }

    let testAction;
    if (testData === 'active') {
      let 
        alternatifStatus,
        alternatifDataTip,
        alternatifTitle,
        alternatifButtonTitle,
        alternatifAppear=false,
        alternatif2Status,
        alternatif2DataTip,
        alternatif2Title,
        alternatif2ButtonTitle,
        alternatif2Appear=false,
        rejectStatus,
        rejectDataTip,
        rejectTitle,
        rejectButtonTitle,
        rejectAppear=false,
        cancelIconClassName,
        cancelStatus,
        cancelDataTip,
        cancelTitle,
        cancelButtonTitle,
        cancelAppear=false,
        nextStatus,
        nextDataTip,
        nextTitle,
        nextButtonTitle,
        nextAppear=false;
      if (status === 'placed' || status === 'scheduled') {
        rejectStatus='cancel'
        rejectAppear=true
        rejectDataTip="Cancel pesanan"
        rejectTitle='Cancel'
        rejectButtonTitle='CANCEL'
      } else  if (status === 'confirmed') {
        rejectStatus='cancel'
        rejectAppear=true
        rejectDataTip="Cancel pesanan"
        rejectTitle='Cancel'
        rejectButtonTitle='CANCEL'
        cancelStatus="courier_not_found"
        cancelDataTip="Kurir tidak ditemukan"
        cancelTitle="KURIR TIDAK KETEMU"
        cancelButtonTitle="KURIR TIDAK KETEMU"
        cancelAppear=true
        nextStatus='allocate'
        nextAppear=true;
        nextDataTip="Allocate courier";
        nextTitle="Allocate";
        nextButtonTitle="ALLOCATE";
      } else  if (status === 'allocated') {
        rejectStatus='cancel'
        rejectAppear=true
        rejectDataTip="Cancel pesanan"
        rejectTitle='Cancel'
        rejectButtonTitle='CANCEL'
        nextStatus='picking_up'
        nextAppear=true;
        nextDataTip="Courier picking up";
        nextTitle="Picking up";
        nextButtonTitle="START PICKING UP";
      } else  if (status === 'pickingUp') {
        rejectStatus='cancel'
        rejectAppear=true
        rejectDataTip="Cancel pesanan"
        rejectTitle='Cancel'
        rejectButtonTitle='CANCEL'
        nextStatus='picked'
        nextAppear=true;
        nextDataTip="Item picked";
        nextTitle="Picked";
        nextButtonTitle="BARANG DIJEMPUT";
      } else  if (status === 'picked') {
        cancelStatus="on_hold"
        cancelDataTip="Paket Ditahan"
        cancelTitle="Ditahan"
        cancelButtonTitle="DITAHAN"
        cancelAppear=true
        nextStatus='dropping_off'
        nextAppear=true;
        nextDataTip="Menuju pelanggan";
        nextTitle="Dropping off";
        nextButtonTitle="MENUJU PELANGGAN";
      } else  if (status === 'droppingOff') {
        cancelStatus="on_hold"
        cancelDataTip="Paket Ditahan"
        cancelTitle="Ditahan"
        cancelButtonTitle="DITAHAN"
        cancelAppear=true
        alternatifStatus='return_in_transit'
        alternatifDataTip='Proses Return'
        alternatifTitle='Return'
        alternatifButtonTitle='RETURN PROCESS'
        alternatifAppear=true
        alternatif2Status='disposed'
        alternatif2DataTip='Disposed'
        alternatif2Title='Disposed'
        alternatif2ButtonTitle='HANCURKAN PAKET'
        alternatif2Appear=true
        nextStatus='delivered'
        nextAppear=true;
        nextDataTip="Telah sampai";
        nextTitle="Delivered";
        nextButtonTitle="SELESAI";
      } else  if (status === 'onHold') {
        cancelIconClassName="fas fa-arrow-alt-circle-right"
        cancelStatus='dropping_off'
        cancelAppear=true;
        cancelDataTip="Menuju pelanggan";
        cancelTitle="Dropping off";
        cancelButtonTitle="MENUJU PELANGGAN";
        nextStatus='delivered'
        nextAppear=true;
        nextDataTip="Telah sampai";
        nextTitle="Delivered";
        nextButtonTitle="SELESAI";
      } else  if (status === 'returnInTransit') {
        cancelAppear=false;
        nextStatus='returned'
        nextAppear=true;
        nextDataTip="Telah Retur";
        nextTitle="Return";
        nextButtonTitle="RETURN";
      }

      const rejectButton = !rejectAppear ? null : (
        <div className="mb-2 pointer">
            <ReactTooltip/>
            <a onClick={() => updateTestOrder(og.orderId, rejectStatus)}
              className="action-item mr-2"
              data-tip={rejectDataTip}
              title={rejectTitle}>
                <i className="fas fa-times-circle"></i>
            </a><br/>
            <small>{rejectButtonTitle}</small>
        </div>
      )

      const cancelButton = !cancelAppear ? null : (
        <div className="mb-2 pointer">
            <ReactTooltip/>
            <a onClick={() => updateTestOrder(og.orderId, cancelStatus)}
              className="action-item mr-2"
              data-tip={cancelDataTip}
              title={cancelTitle}>
                <i className={`${cancelIconClassName || "fas fa-times-circle"}`}></i>
            </a><br/>
            <small>{cancelButtonTitle}</small>
        </div>
      )

      const nextButton = !nextAppear ? null : (
        <div className="mb-2 pointer">
            <ReactTooltip/>
            <a onClick={() => updateTestOrder(og.orderId, nextStatus)}
              className="action-item mr-2"
              data-tip={nextDataTip}
              title={nextTitle}>
                <i className="fas fa-arrow-alt-circle-right"></i>
            </a><br/>
            <small>{nextButtonTitle}</small>
        </div>
      )

      const alternatifButton = !alternatifAppear ? null : (
        <div className="mb-2 pointer">
            <ReactTooltip/>
            <a onClick={() => updateTestOrder(og.orderId, alternatifStatus)}
              className="action-item mr-2"
              data-tip={alternatifDataTip}
              title={alternatifTitle}>
                <i className="fas fa-arrow-alt-circle-right"></i>
            </a><br/>
            <small>{alternatifButtonTitle}</small>
        </div>
      )

      const alternatif2Button = !alternatif2Appear ? null : (
        <div className="mb-2 pointer">
            <ReactTooltip/>
            <a onClick={() => updateTestOrder(og.orderId, alternatif2Status)}
              className="action-item mr-2"
              data-tip={alternatif2DataTip}
              title={alternatif2Title}>
                <i className="fas fa-arrow-alt-circle-right"></i>
            </a><br/>
            <small>{alternatif2ButtonTitle}</small>
        </div>
      )

      testAction = Status.isStatusAtEndState(status) ? null : (
        <div>
              <span className="badge badge-warning">WEBHOOK</span>
              {rejectButton}
              {cancelButton}
              {alternatifButton}
              {alternatif2Button}
              {nextButton}
        </div>
      )
    }

    return (
        <div>
          {update}
          {trash}
          {print}
          {payment}
          {linkView}
          {fulfillment}
          {testAction}
        </div>
    )
  };

  const modalView = () => {
    let modalBody, size, type, title, bText,bClick, buttons;

    if (modalType === 'print') {
        title = 'Print Label';
        size= 'md';
        modalBody = (
            <div className="p-4">
                <PDFDownloadLink className="btn-block btn btn-light" document={<WaybillOrder order={data}/>} fileName={`label-${data.orderId}.pdf`}>
                    {({ blob, url, loading, error }) => (loading ? 'Memuat label pengiriman...' : 'Download Label')}
                </PDFDownloadLink>
            </div>
        )
    } else if (modalType === 'payment') {
        title = 'Pembayaran QRIS';
        size= 'sm';
        modalBody = (
            <div className="py-4 text-center">
                <p> Silahkan lakukan pembayaran dengan scan QR code dibawah ini </p>
                <QRCode
                    size={156}
                    value={qrCode}/>
                <p> Pembayaran QRIS dengan scan QR Code melalalui aplikasi OVO, Gojek, LinkAja dan lainnya yang mendukung teknologi QRIS.</p>
            </div>
        )
    } else if (modalType === 'printSelected') {
        title = 'Print Selected Label';
        modalBody = (
            <div className="p-4">
                <PDFDownloadLink className="btn-block btn btn-light" document={<WaybillBulkOrder order={selectedData}/>} fileName={`label-${Date.now()}.pdf`}>
                    {({ blob, url, loading, error }) => (loading ? 'Memuat label pengiriman...' : 'Download Label')}
                </PDFDownloadLink>
            </div>
        )
    } else if (modalType === 'delete') {
        buttons = true;
        type = "oneButton";
        size = "md";
        title = "Alasan Cancel";
        bText= `Lanjut Batalkan`;
        bClick= () => onDeleteOrder();
        modalBody = (
            <div className="p-4">
              <select
                  id="inputState"
                  className="form-control"
                  onChange={e => setCancellationReason(e.target.value)}
              >
                {
                  cancelReasons.map((i,idx) => (
                      <option
                          key={idx}
                          value={i}
                          className={`${idx === 0 ? "selected":""}`}
                      >
                        {i}
                      </option>
                  ))
                }
              </select>
            </div>
        )
    } else if (modalType === 'tags') {
      return  (
        <ModalEditTags 
          show={modal} 
          data={selectedData}
          onHide={handleModalClose}
          orderId={selectedOrderId}
        />
      )
    } else if (modalType === 'detail') {
      return  (
        <ModalOrderDetail 
          show={modal} 
          onHide={handleModalClose}
          orderId={selectedOrderId}
        />
      )
    } else if (modalType === 'fulfillment') {
      return  (
        <ModalFulfillment 
          show={modal} 
          data={selectedOrders}
          onHide={handleModalClose}
          orderId={selectedOrderId}
        />
      )
    }

    return (
        <Modal
            buttons={buttons}
            show={modal}
            onHide={handleModalClose}
            title={title}
            bodyClassName="p-0"
            size={size}
            bText={bText}
            bClick={bClick}
            type={type}
        >
          { modalBody }
        </Modal>
    );
  };

  const getTrProps = (state, rowInfo, instance) => {
    if (rowInfo) {
      return {}
    }
    return {};
  };

  return (
    <div>
      { modalView() }
      <EditOrderForm
        orderId={selectedOrderId}
        show={editOrderModal}
        onHide={() => setEditOrderModal(false)}
      />
      <ReactTable
        data={props.data}
        columns={columns}
        minRows={10}
        maxRows={50}
        defaultPageSize={10}
        pageSize={props.data.length}
        loading={props.loading}
        className="-striped -highlight"
        getTrProps={getTrProps}
        showPagination={false}
      />
    </div>
  )
};

export default OrderTable;
